import { EngagementRatingSchema } from "./engagementRating.ts";
import { z } from "zod";

export const EngagementDriverSchema = z.object({
    id: z.string(),
    label: z.string(),
    description: z.string(),
    score: z.number().nullable(),
    scoreRating: EngagementRatingSchema.nullable(),
    scoreDelta: z.number().nullable()
});
export type EngagementDriver = z.infer<typeof EngagementDriverSchema>;

export const EngagementHistoryPointSchema = z.object({
    date: z.string(),
    teamScore: z.number().nullable(),
    companyScore: z.number().nullable()
});
export type EngagementHistoryPoint = z.infer<typeof EngagementHistoryPointSchema>;

export const EngagementSubMetricSchema = z.object({
    id: z.string(),
    label: z.string(),
    description: z.string(),
    score: z.number().nullable(),
    scoreRating: EngagementRatingSchema.nullable(),
    scoreDelta: z.number().nullable()
});
export type EngagementSubMetric = z.infer<typeof EngagementSubMetricSchema>;

export const EngagementQuestionDistributionSchema = z.object({
    stronglyFavorableCount: z.number(),
    favorableCount: z.number(),
    neutralCount: z.number(),
    unfavorableCount: z.number(),
    stronglyUnfavorableCount: z.number()
});
export type EngagementQuestionDistribution = z.infer<typeof EngagementQuestionDistributionSchema>;

const EngagementQuestionReliabilitySchema = z.enum(["Low", "High"]);

export const EngagementQuestionSchema = z.object({
    id: z.string(),
    subMetricId: z.string().optional(),
    subMetricLabel: z.string().optional(),
    metricId: z.string().optional(),
    metricLabel: z.string().optional(),
    questionLabel: z.string(),
    reliability: EngagementQuestionReliabilitySchema.optional(),
    distribution: EngagementQuestionDistributionSchema.nullable(),
    feedbackCount: z.number().nullable().optional()
});
export type EngagementQuestion = z.infer<typeof EngagementQuestionSchema>;
